<!--
	ReferralBanner.svelte

    Similar to PageBanner but styled differently and has sub-text beneath title.
    Hard coded to display "Connect" and the molecular graphic.
-->

<script>
    import { onMount } from 'svelte';
    import { getIsPreferredPartner } from "../../common/utils.js";

    // TCARE components

    // SMUI components
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowLeftCircle } from '@mdi/js';
    import { pop } from 'svelte-spa-router';

    const SVG_CONNECT_PATH = '/svg-icons/button-icons/molecular-ruby.svg';
    
    export let serviceData;
    export let isReferralSubmitted;

    onMount(() => {
    })

</script>

<style>
    .referral-banner {
        width: 98%;
        padding: 10px 1% 10px 0%;
        margin: 20px 0px;
        color: var(--tcui-secondary);
    }

    .referral-banner .back-icon {
        width: 36px;
        height: 36px;
        margin-right: 10px;
    }

    .referral-banner .back-icon:hover {
        transform: scale(1.2);
    }

    :global(.referral-banner .back-icon svg) {
        fill: var(--tcui-secondary);
        transition: all .2s;
    }

    :global(.referral-banner .back-icon svg:hover) {
        fill: var(--tcui-primary);
        transform: scale(1.1);
    }

    .referral-banner .banner-title {
        font-size: 28px;
        font-weight: 400;
        margin-right: 10px;
    }

    .referral-banner .banner-icon {
        margin-top: 20px;
    }

    .referral-banner .banner-text {
        display: block;
        margin-top: -10px;
        font-size: 14px;
        font-weight: 100;
        color: var(--tcui-primary);
    }

    .referral-banner .banner-text span {
        text-decoration: underline;
    }

    .referral-banner .banner-text span:hover {
        color: var(--tcui-secondary);
        cursor: pointer;
    }

    .referral-banner .banner-text-2 {
        margin-top: 10px;
        font-size: 15px;
        font-weight: 800;
        color: var(--tcui-primary);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- hide this box if on the SuccessPage - reactivated 11/3 -->
<!-- {#if !isReferralSubmitted} -->

    <div class="referral-banner"> 
        <div class="flex-row jc-start fs-2 fw-100">
            <div class="back-icon" on:click={() => pop()}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftCircle} /></Icon>	
            </div>
            <div class="banner-title">
                Connect
            </div>
            <div class="banner-icon">
                <img src={SVG_CONNECT_PATH} alt={'Connect'} draggable='false'>
            </div>
        </div>
        <div class="flex-row jc-start banner-text">
            Filling out this form sends a copy of this service and records it in <span>“My Resources”</span>.<br/>
        </div>

        <div class="flex-row jc-start banner-text-2">
            {#if getIsPreferredPartner(serviceData)}
                This information will be sent to the service.
            {:else}
                This information will not be sent to the service.
            {/if}
        </div>

    </div>

<!-- {/if} -->

